<template>
    <div class="py-5 md:py-10">
        <div v-if="status === 'pending' && allItems.length === 0"
            class="flex justify-center">
            <v-spinner size="lg" />
        </div>

        <v-info v-else-if="allItems.length === 0"
            class="text-center text-gray-600">
            {{ $t('reviews.no-reviews') }}
        </v-info>

        <template v-else>
            <template v-for="(review, index) in allItems"
                :key="review.id">
                <hr v-if="index > 0"
                    class="my-5 md:my-10">

                <div class="md:grid md:grid-cols-4 md:divide-x">
                    <div class="space-y-1 py-1">
                        <p v-if="review.isVerifiedBuyer"
                            class="flex h-6 items-center space-x-2 text-gray-600">
                            <span class="flex size-4 items-center justify-center rounded-full
                                bg-green-600 text-xs text-white">
                                <v-icon icon="check" />
                            </span>

                            <span class="text-sm">
                                {{ $t('reviews.verified-customer') }}
                            </span>
                        </p>

                        <p class="font-bold">
                            {{ review.author }}
                        </p>
                    </div>

                    <div class="py-1 md:col-span-3 md:px-5">
                        <div class="mb-4 flex h-6 items-center space-x-px">
                            <v-icon v-for="i in 5"
                                :key="i"
                                :icon="getIcon(i, review.rating)" />
                        </div>

                        <p>{{ review.content }}</p>

                        <p class="mt-6 text-right text-xs text-gray-600">
                            {{ formatDistance(review.date) }}
                        </p>
                    </div>
                </div>
            </template>

            <div class="mx-auto mt-20 w-full space-y-8 md:w-2/3">
                <v-button class="w-full"
                    :theme="!areAllLoaded ? 'black' : 'gray'"
                    :disabled="areAllLoaded"
                    @click="currentPage += 1">
                    {{
                        areAllLoaded
                            ? $t('reviews.loader.show-more-reviews-loaded')
                            : $t('reviews.loader.show-more')
                    }}
                </v-button>

                <v-progress-bar :total="totalCount"
                    :current="allItems.length">
                    {{
                        $t('reviews.loader.show-more-count', {
                            current: allItems.length,
                            total: totalCount
                        })
                    }}
                </v-progress-bar>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { whenever } from '@vueuse/core';

const properties = defineProps<{
    skus: string[]
}>();

const {
    getReviews,
    getIcon,
} = useReviews();

const { formatDistance } = useDate();

const currentPage = ref(1);

const {
    reviews,
    totalCount,
    status,
} = getReviews(properties.skus, currentPage);

const allItems = ref<typeof reviews.value>([]);
const areAllLoaded = computed(() => (allItems.value.length >= totalCount.value));

whenever(reviews, (value) => {
    allItems.value = [...allItems.value, ...value];
});
</script>
